import { styled } from "styled-components";


const ContentWrap = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-height: 70vh;
  overflow: auto;

  .list-item {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #b0aeae;
    border-radius: 6px;
    padding: 8px;
    margin-bottom: 8px;
  }

`
export default ContentWrap;